<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="fm-title">Contents</p>
<p class="tocfm"><a href="#/xhtml/06_Preface">Preface: Modern Warfare Series</a></p>
<p class="tocfm1"><a href="#/xhtml/07_Introduction">Introduction: The Cold War</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01">Chapter One</a></p>
<p class="toc1a"><a href="#/xhtml/08_Chapter01">T-54/55 Main Battle Tank</a></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc1a"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">T-62 &amp; T-64 Main Battle Tanks</span></p>
<p class="toc1"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc1a"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">T-72 &amp; T-80 Main Battle Tanks</span></p>
<p class="toc1"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc1a"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample">PT-76 Amphibious Light Tank</span></p>
<p class="toc1"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc1a"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample">BTR Wheeled Armoured Personnel Carriers</span></p>
<p class="toc1"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">Chapter Six</span></p>
<p class="toc1a"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample">BMP Infantry Fighting Vehicle &amp; MT-LB Armoured Personnel Carrier</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="toc1a"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample">ASU Airborne Assault Vehicle &amp; BMD Airborne Combat Vehicle</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="toc1a"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample">BRDM Amphibious Scout Car</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="toc1a"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample">Self-Propelled Artillery</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="toc1a"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample">Anti-Tank Missiles</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="toc1a"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample">Anti-Tank Helicopters</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="toc1b"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample">Soviet Equipment in Combat</span></p>
<p class="tocfm"><span href="#/xhtml/20_Epilogue" title="Link target outside of Sample">Epilogue: Money Not Tanks</span></p>
<p class="tocfm"><span href="#/xhtml/21_Suggested_Further_Reading" title="Link target outside of Sample">Suggested Further Reading</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?c2a260fc